/**
 * Styles for MenuScope component
 * @module containers/MenuScope/styles
 */
import { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

/**
 * Styles hook for MenuScope component
 * @param theme - MUI theme
 * @returns Style classes
 */
// @ts-ignore
const useStyles = makeStyles<Theme>((theme) => ({
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    padding: theme.spacing(6, 4),
    minHeight: 'calc(100vh - 120px)',
    backgroundColor: theme.palette.background.default,
  },
  headerSection: {
    textAlign: 'center',
    marginBottom: theme.spacing(6),
    maxWidth: 800,
  },
  cardsContainer: {
    display: 'flex',
    justifyContent: 'center',
    gap: theme.spacing(4),
    flexWrap: 'wrap',
    maxWidth: 800,
  },
  cardWrapper: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  errorMessage: {
    textAlign: 'center',
    color: theme.palette.text.primary,
    fontWeight: theme.typography.fontWeightRegular,
    fontSize: theme.typography.pxToRem(14),
    lineHeight: theme.typography.pxToRem(20),
    marginTop: theme.spacing(2),
    maxWidth: theme.typography.pxToRem(320), // Same width as the card
  },
}));

export default useStyles;
